import { callService, serviceReducer } from "../../../hooks/serviceReducer";
import { Action, ApiState } from "../../../misc/api.types";
import { PagedFilter } from "../../../misc/pagedFilter";
import { ApproversResult } from "../../../models/approver.model";


export type ResultAction =
  | Action<ApproversResult>
  | { type: "PAGE"; value: number }
  | { type: "PAGE_SIZE"; value: number }
  | { type: "SEARCH"; value: PagedFilter }
  | { type: "ORDER"; column: string; sortDescending: boolean };

const reducer = (
  state: ApiState<ApproversResult, PagedFilter>,
  action: ResultAction
): ApiState<ApproversResult, PagedFilter> => {
  switch (action.type) {
    case "PAGE": {
      return callService(state, { ...state.filter, pageNumber: action.value });
    }
    case "PAGE_SIZE": {
      return callService(state, {
        ...state.filter,
        pageNumber: 1,
        pageSize: action.value,
      });
    }
    case "SEARCH": {
      return callService(state, { ...state.filter, ...action.value });
    }
    case "ORDER": {
      return callService(state, {
        ...state.filter,
        sortField: action.column,
        sortDescending: action.sortDescending,
      });
    }
    default:
      return serviceReducer(state, action);
  }
};

export default reducer;
